export function createHeaders(workspaceId) {
    const defaultHeaders = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
    };
    return workspaceId ? { ...defaultHeaders, "X-Workspace-ID": workspaceId } : { ...defaultHeaders };
}
export const fallbackFactory = (defaultData) => ({
    data: defaultData,
    error: new Error("Your have some missing parameters to fetch data"),
    isLoading: false,
    trigger: async () => {
        throw new Error("Your have some missing parameters to fetch data");
    },
    refetch: async () => {
        throw new Error("Your have some missing parameters to fetch data");
    },
});
export function createFallBackResponse(entityName, defaultData) {
    console.warn(`Creating fallback response for ${entityName || "unknown"}. Pass appropriate parameters to fetch data.`);
    return fallbackFactory(defaultData);
}
